import React from 'react';
import { Form } from 'react-bootstrap';
import { Controller, FieldError, useFormContext } from 'react-hook-form';

export interface ISelectItem {
    value: any;
    title: string;
}

const HookRadioFormControl = (props: any) => {
    const { name, label, rules, type, groupName, inline = true, ...rest } = props;
    const form = useFormContext();

    return (
        <>
            <Controller
                name={name}
                render={({ field }) => (
                    <Form.Check
                        type="radio"
                        {...field}
                        {...rest}
                        isInvalid={form.formState.errors[name]}
                        onChange={(value) => {
                            field.onChange(value);
                            if (props.onChange) {
                                props.onChange(value);
                            }
                        }}
                        style={{ verticalAlign: 'top' }}
                        id={props.value}
                        label={label}
                        inline={inline}
                        onClick={() => {
                            form.setValue(name, props.value);
                        }}
                        checked={form.getValues()[name] === props.value}
                    ></Form.Check>
                )}
                control={form.control}
                defaultValue={form.getValues()[name] === props.value}
                rules={rules}
            />
            <Form.Control.Feedback type="invalid">
                {(form.formState.errors[name] as FieldError)?.message}
            </Form.Control.Feedback>
        </>
    );
};

export default HookRadioFormControl;
